import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "size"];
import React, { useContext } from 'react';
import PT from 'prop-types';
import { intrinsicComponent } from '../../utils/functions';
import Styled from './drawer.styles';
import DrawerContext from './drawer.context';
var DrawerItemIcon = intrinsicComponent(function (_ref, ref) {
  var children = _ref.children,
    iconSize = _ref.size,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(DrawerContext),
    isCollapsed = _useContext.isCollapsed,
    size = _useContext.size;
  return /*#__PURE__*/React.createElement(Styled.Icon, _extends({}, rest, {
    isCollapsed: isCollapsed,
    ref: ref
  }), children && typeof children === 'function' ? children({
    size: size || iconSize
  }) : children);
});
DrawerItemIcon.defaultProps = {
  size: 20
};
DrawerItemIcon.propTypes = {
  size: PT.number,
  children: PT.oneOfType([PT.node, PT.func]).isRequired
};
export default DrawerItemIcon;